import { Link, useParams } from 'react-router-dom'
import { Player } from '../assets/data'
interface PlayerDetailsProps {
  players: Player[]
}
export const PlayerDetails = ({ players }: PlayerDetailsProps) => {
  const { slug } = useParams()
  const player = players.find((p) => p.slug === slug)

  // Roster hasn't loaded yet (e.g. a fresh page load straight to this URL).
  if (players.length === 0) {
    return <p style={{ marginTop: '3rem' }}>Loading…</p>
  }

  if (!player) {
    return (
      <div style={{ marginTop: '3rem' }}>
        <h2>Player not found</h2>
        <Link to="/">Back to all players</Link>
      </div>
    )
  }

  const { wins, losses } = player.stats
  const pct = Math.round((wins / (wins + losses)) * 1000) / 10
  return (
    <div className="player-details">
      <div className="player-details__media" title={player.name}>
        <img src={player.image} alt={player.name} />
      </div>
      <div className="player-details__info" title={player.name}>
        <ul>
          <li>
            <h2>Name: {player.name}</h2>
          </li>
          <li>
            <h2>Born:</h2>
            <ul>
              <li>
                <h3>{player.birthdate}</h3>
              </li>
              <li>
                <h3>
                  {player.city}, {player.country}
                </h3>
              </li>
            </ul>
          </li>
          <li>
            <h2>Stats:</h2>
            <ul>
              <li>
                <h3>Wins: {wins}</h3>
              </li>
              <li>
                <h3>Losses: {losses}</h3>
              </li>
              <li>
                <h3>Win percentage: {pct}%</h3>
              </li>
            </ul>
          </li>
          <li>
            <h2>About: {player.bio}</h2>
          </li>
        </ul>
      </div>
    </div>
  )
}
